import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";

import AboutImageOne from "../images/about/about1.png";
import AboutImageTwo from "../images/about/about2.png";
const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <MainFeature1
        subheading={<Subheading>About Vizual Ads</Subheading>}
        heading="Where modern design meets precision printing."
        description="Discover Vizual Ads, an award-winning Digital Creative Agency in Ohio, offering cutting-edge Web Design, Development, Branding, Digital Marketing, E-Commerce, WordPress, & premium Printing Services under one roof."
        buttonRounded={false}
        primaryButtonText="See Portfolio"
        primaryButtonUrl="/design-ads"
        imageSrc={AboutImageOne}
      />
      <MainFeature1
        subheading={<Subheading>Our Vision</Subheading>}
        heading="Integrating creative design and precision printing to strengthen your brand identity."
        description="Vizual Ads is a vibrant Ohio-based advertising and marketing agency, blending creative storytelling, brand marketing, and professional printing services to deliver meaningful, universally appealing brand experiences."
        buttonRounded={false}
        primaryButtonText="Connect"
        primaryButtonUrl="/contact-us"
        imageSrc={AboutImageTwo}
        textOnLeft={false}
      />
      <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading=" Right Vision. Right Team."
        description="Integrity is the foundation for everything we do. We are admired and respected for our commitment to honesty, trust, and transparency."
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support"
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams"
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction"
          },
        ]}
        linkText=""
      />
      <TeamCardGrid
        subheading={<Subheading>Our Team</Subheading>}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
